export default __webpack_public_path__ + "static/arindamLehri3-10dcf17462488ac68483406eca16f142.jpg";